'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AITutorSyncContent from './components/AITutorSyncContent';

export default function AITutorSyncPage() {
  return (
    <AppLayout role="admin" campusMode="pro">
      <AITutorSyncContent />
    </AppLayout>
  );
}
